(function () {
    'use strict';
    angular
        .module('ipmApp')
        .directive('adjustBodyHeight', adjustBodyHeight);
    adjustBodyHeight.$inject = ['$document', '$timeout'];

    function adjustBodyHeight($document, $timeout) {
        return {
            require: '^uibDropdown',
            link: function (scope, elem, attrs, dropdownCtrl) {
                var body = $document[0].body;
                var openTimer = null;
                var clickHandler = null;

                function resetMinHeight() {
                    body.style.removeProperty('min-height');
                }

                scope.$watch(function () {
                    return dropdownCtrl.isOpen();
                }, function (isOpen) {
                    if (isOpen) {
                        if (openTimer) {
                            $timeout.cancel(openTimer);
                        }
                        openTimer = $timeout(function () {
                            var menu = elem[0].querySelector('[uib-dropdown-menu]');
                            if (!menu) {
                                return;
                            }
                            if (!clickHandler) {
                                clickHandler = function () {
                                    resetMinHeight();
                                };
                                menu.addEventListener('click', clickHandler);
                            }
                            var rect = menu.getBoundingClientRect();
                            var over = rect.bottom - window.innerHeight;
                            if (over > 0) {
                                body.style.minHeight = body.offsetHeight + over + 'px';
                            }
                        });
                    } else {
                        if (openTimer) {
                            $timeout.cancel(openTimer);
                            openTimer = null;
                        }
                        var menu = elem[0].querySelector('[uib-dropdown-menu]');
                        if (menu && clickHandler) {
                            menu.removeEventListener('click', clickHandler);
                            clickHandler = null;
                        }
                        $timeout(resetMinHeight);
                    }
                });
                scope.$on('$destroy', function () {
                    if (openTimer) {
                        $timeout.cancel(openTimer);
                    }
                    resetMinHeight();
                });
            }
        };
    }
})();
